import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
  @Output() sideNavToggled = new EventEmitter<void>();

  constructor(private readonly router: Router) {}

  ngOnInit() {}

  toggleSidebar() {
    this.sideNavToggled.emit();
  }

  onLoggedout() {
    // console.log('salir')
    localStorage.setItem('isLoggedin', "false");
    localStorage.removeItem('idPerfil');
    localStorage.removeItem('token');
    localStorage.removeItem('idUsuario');
    // localStorage.removeItem('users');
    this.router.navigate(['/login']);
  }
}
